import { Subscription } from "rxjs";
import { StorageModule } from "./../../utils/storage.module";
import { RestService } from "./../../services/rest/rest.service";
import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
    OnInit,
    ViewChild,
    Inject,
} from "@angular/core";
import { PageService } from "../../services/page.service";
import { ProposalResponse } from "../../model/proposal-response";
import { ROUTES } from "../../utils/routes";
import { ErrorTypeEnum } from "../../enum/error-title.enum";

export interface IErrorDialog {
    title: string;
    description: string;
    statusCode: number;
    isLoadError?: boolean;
    firstAction?: {
        name: string;
        title: string;
    };
    secondAction?: {
        name: string;
        title: string;
    };
    serviceError?: any;
}
type ModalError = {
    title: string;
    buttonText: string;
};

@Component({
    selector: "mob-page",
    templateUrl: "./page.component.html",
    styleUrls: ["./page.component.scss"],
})
export class PageComponent implements OnInit {
    @Input() title: string;
    @Input() subtitle: string;
    @Input() icon: string;
    @Input() primaryAction: any;
    @Input() secondaryAction: any;
    @Input() mode: string;
    @Input() primaryActionEnabled?: boolean = true;
    @Input() secondaryActionEnabled?: boolean = true;
    @Input() textAlign?: string;
    @Input() alertBox?: any;
    @Output() onErrorAction = new EventEmitter();
    @Output() actionClicked = new EventEmitter();

    @ViewChild("modalError") modalError;

    public openErrorDialog: boolean = false;
    public errorMessageModal: ModalError;
    public subHandleErrorModal: Subscription;

    error: IErrorDialog = {
        title: "",
        description: "",
        statusCode: 200,
        isLoadError: false,
        firstAction: {
            name: "retry",
            title: "Tentar novamente",
        },
    };

    constructor(
        @Inject(PageService) public pageService: PageService,
        @Inject(RestService) private restService: RestService,
        @Inject(StorageModule) private storage: StorageModule
    ) {}
    onActionClick(event) {
        if (event.action.indexOf("none") < 0) {
            this.actionClicked.emit({ actionName: event.action });
        }
    }

    ngOnInit() {
        this.openErrorServiceModal();
    }

    openErrorServiceModal() {
        this.pageService.handleChangesModalError.subscribe(
            (val: IErrorDialog) => {
                this.error = val;
                this.openErrorDialog = true;
                this.onErrorAction.emit(this.error);
            }
        );
    }

    goToAction(event) {
        this.openErrorDialog = false;
        const errorName = event.firstAction.name;
        if (errorName === ErrorTypeEnum.TOKEN) {
            this.pageService.goToPage(ROUTES.identification.url);
        } else {
            if (event.isLoadError) {
                this.pageService.isPageLoading = true;
                this.callLoadNextStep();
            } else {
                this.pageService.isPageLoading = false;
            }
        }
    }

    callLoadNextStep() {
        let currentData = this.storage.getCurrentStepData();

        this.restService
            .postLoad({ hashId: this.storage.getPropHashId() }, {})
            .subscribe((data: ProposalResponse) => {
                if (data.nextStep !== currentData.nextStep) {
                    this.pageService.goToNext(data.nextStep, data);
                }
            });
    }

    ngOnDestroy() {
        if (this.subHandleErrorModal) this.subHandleErrorModal.unsubscribe();
    }
}

